/*
 * Background route prefetching.
 *
 * These imports match the lazy routes in App.js.
 * Webpack can reuse the generated route chunks.
 */

const routeLoaders = {
  "/upload": () => import("./pages/Upload"),
  "/inbox": () => import("./pages/Inbox"),
  "/profile": () => import("./pages/Profile"),
  "/wallet": () => import("./pages/Wallet"),
  "/discover": () => import("./pages/Discover"),
};

const prefetched = new Set();

export function prefetchRoute(path) {
  const loader = routeLoaders[path];

  if (!loader || prefetched.has(path)) {
    return;
  }

  prefetched.add(path);

  loader().catch(() => {
    /*
     * If prefetch fails, don't prevent the actual
     * navigation from loading the page later.
     */
    prefetched.delete(path);
  });
}

export function prefetchCommonRoutes() {
  /*
   * Respect users who have deliberately enabled
   * reduced-data mode.
   */
  const connection =
    navigator.connection ||
    navigator.mozConnection ||
    navigator.webkitConnection;

  if (
    connection?.saveData ||
    connection?.effectiveType === "slow-2g" ||
    connection?.effectiveType === "2g"
  ) {
    return;
  }

  const paths = [
    "/profile",
    "/inbox",
    "/upload",
    "/wallet",
    "/discover",
  ];

  paths.forEach(prefetchRoute);
}
